import fb from '@/services/firebase'

export const namespaced = true

export const state = {
  current_orders: [],
  driver_location: {},
  loading: false
}

export const mutations = {
  SET_CURRENT_ORDERS(state, values) {
    state.current_orders = values
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_DRIVER_LOCATION(state, payload) {
    state.driver_location = payload
  }
}

export const actions = {
  currentOrders({ commit }) {
    commit('SET_LOADING', true)
    commit('SET_CURRENT_ORDERS', [])
    fb.auth.onAuthStateChanged(user => {
      if (user) {
        fb.db
          .collection('orders')
          .where('placing_order.finished_at', '!=', null)
          .where('initiator_uid', '==', user.uid)
          .onSnapshot(docs => {
            if (docs.empty == false) {
              var orders = []
              docs.forEach(doc => {
                var newDoc = doc.data()
                newDoc.doc_id = doc.id
                orders.push(newDoc)
              })
              commit('SET_CURRENT_ORDERS', orders)
            } else {
              commit('SET_CURRENT_ORDERS', [])
            }
          })
      }
    })
  },
  driverLocation({ commit }, payload) {
    commit('SET_DRIVER_LOCATION', {})
    fb.db
      .collection('drivers')
      .doc(payload)
      .onSnapshot(docs => {
        commit('SET_DRIVER_LOCATION', docs.data().location)
      })
  }
}

export const getters = {}
